import sectionCardStepInstructionsCss from '../css-snippets/section-card-step-instructions';

const html = `
<style>${sectionCardStepInstructionsCss}</style>
<div
  class="card-step-instructions card-step-instructions-unique-id"
  data-id="unique-id"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="card-step-instructions-container container">
    <div class="steps-title" data-attribute="steps-title">
      <h2 style="text-align: center"><strong>How Does VetiFlow™ Work?</strong></h2>
    </div>
    <div class="swiper">
      <div class="card-container swiper-wrapper" data-attribute="card-container">
        <div class="card-item swiper-slide">
          <div class="step-image">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/22/image-6948b78b53bce07a354822e6.webp?w=500&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="step-number">1</div>
          <div class="step-content">
            Place VetiFlow anywhere in your home - kitchen, living room, or
            wherever your dog drinks. Fill with tap water. The device
            automatically activates 24/7.
          </div>
        </div>
        <div class="card-item swiper-slide">
          <div class="step-image">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/22/image-6948b79fd6f1105a188b0bd7.webp?w=500&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="step-number">2</div>
          <div class="step-content">
            When filled, VetiFlow instantly begins circulating water through the
            Triple-Defense system. Water moves continuously, filters 50+ times
            daily, preventing the 8-hour biofilm window.
          </div>
        </div>
        <div class="card-item swiper-slide">
          <div class="step-image">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/22/image-6948b7ef605f85a7c311a166.webp?w=500&h=50&q=80"
              alt="image"
            />
          </div>
          <div class="step-number">3</div>
          <div class="step-content">
            Your dog drinks clean, fresh water immediately. Within days, you
            notice them drinking more. No daily scrubbing needed - just a weekly
            rinse. Biofilm never forms again.
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
`;

export default html;
